import { OPERATIONTYPES, invalidStr, xsdPathStr } from "../../../../globals/constants";
import { IFullDeviceDetails, IGeneralAuth } from "../../../../store/api/deviceConfig/types";
import { ISiteOfflineDetails } from "../../../../store/api/devices/types";
import { isIPv4, isIPv6, isServer, isValidHostName, isValidProfileAttributeType, isValidServerPort } from "../../../../utils/validations";
import { IKeyValue, IRadius, ISaml, IServerAddress, ITacacs } from "../../types";

export const validateRadius = (data: IRadius | ITacacs) => {
  const { ipAddress, port } = invalidStr;
  let errorMessages = {} as IKeyValue;
  Object.entries(data).forEach(([key, value]) => {
    switch (key) {
      case "serverAddress":
        if (!!value) {
          const isValidServer = isIPv4(value) || isIPv6(value) || isServer(value); // || value.toLowerCase() === "localhost";
          if (!isValidServer) {
            errorMessages[key] = "Invalid Server Address!";
          }
        } else {
          errorMessages[key] = ipAddress.required.replace("IP Address", "Server address");
        }

        break;

      case "sharedSecret":
        if (data.isChangeSharedSecret) {
          //   if (!!data.confirmSharedSecret && !!value && data.confirmSharedSecret !== value) {
          //     errorMessages["confirmSharedSecret"] = "Shared sceret does not match!";
          //   } else {
          //     errorMessages[key] = "Shared sceret is required";
          //   }
          if (!!!value) {
            errorMessages[key] = "Shared sceret is required";
          }
        }

        break;
      case "confirmSharedSecret":
        if (data.isChangeSharedSecret) {
          if (!!value) {
            if (data.sharedSecret !== value) {
              errorMessages[key] = "Shared sceret does not match!";
            }
          } else {
            errorMessages[key] = "Confirm shared sceret is required!";
          }
        }

        break;
      // case "port":
      //   if (!!value) {
      //     const isValidPort = isValidServerPort(value);
      //     if (!isValidPort) {
      //       errorMessages[key] = port.invalid;
      //     }
      //   } else {
      //     errorMessages[key] = "Por is required!";
      //   }

      //   break;
      // case "profileAttributeType":
      //   if (!!value) {
      //     const isValidAttributeType = isValidProfileAttributeType(value);
      //     if (!isValidAttributeType) {
      //       errorMessages[key] = port.type;
      //     }
      //   } else {
      //     errorMessages[key] = "Confirm shared sceret is required!";
      //   }
      //   break;

      default:
        break;
    }
  });

  return errorMessages;
};

export const validateIPAddressList = (data: IServerAddress, isEnable: boolean) => {
  const { ipAddress } = invalidStr;
  let errorMessages = {} as IKeyValue;
  Object.entries(data).forEach(([key, value]) => {
    switch (key) {
      case "ipAddressesList":
        if (!!value) {
          const isValidServer = isValidHostName(value) || isIPv4(value) || isIPv6(value) || isServer(value); // || value.toLowerCase() === "localhost";
          if (!isValidServer) {
            errorMessages[key] = "Invalid IP Address or hostaname!";
          }
        } else {
          if (isEnable) {
            errorMessages[key] = ipAddress.required;
          }
        }
        break;
      default:
        break;
    }
  });

  return errorMessages;
};

export const validateSaml = (data: ISaml) => {
  let errorMessages = {} as IKeyValue;
  Object.entries(data).forEach(([key, value]) => {
    switch (key) {
      case "authorizedServersList":
        if (value && value.length > 0) {
          value.forEach((item: string, i: number) => {
            const index = i + 1;
            if (!!!item) {
              errorMessages[`samlServer${index}`] = `SAML Server ${index} is required`;
            } else {
              errorMessages[`samlServer${index}`] = "";
            }
          });
        }
        break;
      default:
        break;
    }
  });
  return errorMessages;
};

export const authSetupvalues = {
  spiderNetAuth: "SpiderNetDbAuthOnly",
  externalAuth: "ExternalAuthOnly",
  combinedAuth: "CombinedAuth",
};
export const prepareGeneralAuthData = (generalAuthData: any) => {
  const { generalAuthentication } = xsdPathStr;
  if (!!generalAuthData?.data) {
    return {
      authenticationExternal: generalAuthData?.data[generalAuthentication.authenticationExternal],
      authenticationSetup: generalAuthData?.data[generalAuthentication.authenticationSetup],
    } as IGeneralAuth;
  } else {
    return { authenticationSetup: authSetupvalues.spiderNetAuth, authenticationExternal: "" };
  }
};

export const prepareRadiusData = (radiusData: any) => {
  const { radius } = xsdPathStr;
  if (!!radiusData?.data) {
    return {
      serverAddress: radiusData?.data[radius.serverAddress],
      port: radiusData?.data[radius.port],
      profileAttributeType: radiusData?.data[radius.profileAttributeType],
      sharedSecret: radiusData?.data[radius.sharedSecret],
      confirmSharedSecret: "",
      isChangeSharedSecret: !!radiusData?.data[radius.sharedSecret],
    } as IRadius;
  } else {
    return {
      serverAddress: "",
      port: "",
      profileAttributeType: "",
      sharedSecret: "",
      confirmSharedSecret: "",
      isChangeSharedSecret: false,
    } as IRadius;
  }
};

export const prepareRadiusPayload = (radiusData: IRadius) => {
  const { radius } = xsdPathStr;
  return {
    actionType: OPERATIONTYPES.SETRADIUS,
    errDescription: "No description",
    domainKey: "N/A",
    data: {
      [radius.serverAddress]: radiusData.serverAddress,
      [radius.port]: radiusData.port,
      [radius.profileAttributeType]: radiusData.profileAttributeType,
      [radius.sharedSecret]: radiusData.sharedSecret,
    },
  };
};

export const prepareTacacsData = (tacacsData: any) => {
  const { tacacs } = xsdPathStr;
  if (!!tacacsData?.data) {
    return {
      serverAddress: tacacsData?.data[tacacs.serverAddress],
      port: tacacsData?.data[tacacs.port],
      profileAttributeName: tacacsData?.data[tacacs.profileAttributeName],
      sharedSecret: tacacsData?.data[tacacs.sharedSecret],
      confirmSharedSecret: "",
      isChangeSharedSecret: !!tacacsData?.data[tacacs.sharedSecret],
    } as ITacacs;
  } else {
    return {
      serverAddress: "",
      port: "",
      profileAttributeName: "",
      sharedSecret: "",
      confirmSharedSecret: "",
      isChangeSharedSecret: false,
    } as ITacacs;
  }
};

export const prepareTacacsPayload = (tacacsData: ITacacs) => {
  const { tacacs } = xsdPathStr;
  return {
    actionType: OPERATIONTYPES.SETTACACS,
    errDescription: "No description",
    domainKey: "N/A",
    data: {
      [tacacs.serverAddress]: tacacsData.serverAddress,
      [tacacs.port]: tacacsData.port,
      [tacacs.profileAttributeName]: tacacsData.profileAttributeName,
      [tacacs.sharedSecret]: tacacsData.sharedSecret,
    },
  };
};

export const prepareSamlData = (samlData: any) => {
  const { saml } = xsdPathStr;
  if (!!samlData?.data) {
    const serverListStr = samlData?.data[saml.authorizedServersList] || "";
    const serverListStrArray =
      !!serverListStr && !!serverListStr.match(",")
        ? serverListStr.split(",")
        : !!serverListStr && !!!serverListStr.match(",")
        ? [serverListStr]
        : [""];
    return {
      authorizedServersList: serverListStrArray,
      caEnable: samlData?.data[saml.caEnable],
      profileAttributeName: samlData?.data[saml.profileAttributeName],
      usernameAttributeName: samlData?.data[saml.usernameAttributeName],
      samlVersion: samlData?.data[saml.samlVersion],
    } as ISaml;
  } else {
    return {
      authorizedServersList: [""],
      caEnable: false,
      profileAttributeName: "",
      usernameAttributeName: "",
    } as ISaml;
  }
};

export const prepareSamlPayload = (samlData: ISaml) => {
  const { saml } = xsdPathStr;
  return {
    actionType: OPERATIONTYPES.SETSAML,
    errDescription: "No description",
    domainKey: "N/A",
    data: {
      [saml.authorizedServersList]: samlData.authorizedServersList.join(","),
      [saml.profileAttributeName]: samlData.profileAttributeName,
      [saml.usernameAttributeName]: samlData.usernameAttributeName,
      [saml.caEnable]: samlData.caEnable,
      [saml.samlVersion]: samlData.samlVersion,
    },
  };
};

export const prepareOfflineSitePayload = (siteOfflineDetails: ISiteOfflineDetails) => {
  return {
    objectKey: siteOfflineDetails.serialNumber,
    siteGroupId: siteOfflineDetails.group,
    serialNumber: siteOfflineDetails.serialNumber,
    name: siteOfflineDetails.siteName,
    swVersion: siteOfflineDetails.version,
    latitude: siteOfflineDetails.latitude,
    longitude: siteOfflineDetails.longitude,
    modelName: siteOfflineDetails.modelNumber,
    manufacturer: "",
    contact: "",
    dmDisplayType: siteOfflineDetails.siteType || "",
    domainKey: "",
    lastInform: "",
    ipAddress: siteOfflineDetails.ipAddress,
    snmpPort: siteOfflineDetails.snmpPort,
    snmpVersion: siteOfflineDetails.snmpVersion,
    timeout: siteOfflineDetails.timeout,
    writeCommunity: siteOfflineDetails.writeCommunity,
    readCommunity: siteOfflineDetails.readCommunity,
    username: siteOfflineDetails.username,
    contextName: siteOfflineDetails.contextName,
    authProtocol: siteOfflineDetails.authProtocol,
    authPassword: siteOfflineDetails.authPassword,
    privacyProtocol: siteOfflineDetails.privacyProtocol,
    privacyPassword: siteOfflineDetails.privacyPassword,
    urlAddress: siteOfflineDetails.urlAddress || "",
  }
};

export const prepareOfflineSnmpPayload = (offlineSnmpDetails: IFullDeviceDetails) => {
  return {
    geoRegionName: offlineSnmpDetails.geoRegionName,
    objectKey: offlineSnmpDetails.serialNumber,
    siteGroupId: offlineSnmpDetails.siteGroupId || "",
    parentKey: offlineSnmpDetails.siteGroupName,
    serialNumber: offlineSnmpDetails.serialNumber,
    name: offlineSnmpDetails.name,
    swVersion: "",
    latitude: offlineSnmpDetails.latitude.toString(),
    longitude: offlineSnmpDetails.longitude.toString(),
    modelName: offlineSnmpDetails.modelName,
    manufacturer: "",
    contact: "",
    dmDisplayType: offlineSnmpDetails.dmDisplayType || "",
    domainKey: "",
    lastInform: "",
    ipAddress: offlineSnmpDetails.ipAddress,
    snmpPort: offlineSnmpDetails.port,
    snmpVersion: offlineSnmpDetails.snmpVersion,
    timeout: offlineSnmpDetails.timeout,
    writeCommunity: offlineSnmpDetails.writeCommunity,
    readCommunity: offlineSnmpDetails.readCommunity,
    username: offlineSnmpDetails.username,
    contextName: offlineSnmpDetails.contextName,
    authProtocol: offlineSnmpDetails.authProtocol,
    authPassword: offlineSnmpDetails.authPassword,
    privacyProtocol: offlineSnmpDetails.privacyProtocol,
    privacyPassword: offlineSnmpDetails.privacyPassword,
    urlAddress: offlineSnmpDetails.urlAddress || "",
  }
};
